<template>
  <p class="section-label" :style="order > 1 && 'padding-top: 20px'">{{ label }}</p>
</template>

<script>
export default {
  name: 'form-section-label',
  props: {
    label: {
      type: String,
      default: null,
    },
    order: {
      type: Number,
      default: null,
    },
  },
}
</script>

<style scoped>
.section-label {
  font-family: 'Raleway';
  font-size: 20px;
  line-height: 32px;
  font-weight: bold;
  margin-bottom: 0px !important;
  color: #0277bd;
}
</style>
